import React from "react";
import App from "./App";
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import { store } from "./store";
import './i18n/index.ts';
import { UIProvider } from "./ui";


import "./index.css";


let ReactDOM = require("react-dom/client");
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <UIProvider>
        <BrowserRouter>
            <Provider store={store}>
                <App/>
            </Provider>
        </BrowserRouter>
    </UIProvider>
);
